export const profilesData = [
  {
    url: 'https://www.linkedin.com/in/jindal2209',
    icon: 'fab fa-linkedin-in',
    iconClass: 'ln'
  },
  {
    url: 'https://www.github.com/jindal2209',
    icon: 'fab fa-github',
    iconClass: 'gh'
  },
  {
    url: 'https://leetcode.com/shubham7811/',
    icon: 'fas fa-code',
    iconClass: 'lc'
  },
  // {
  //   url: 'https://www.hackerrank.com/shubham7811',
  //   icon: 'fab fa-hackerrank',
  //   iconClass: 'hr'
  // },
  {
    url: '#contact',
    icon: 'fas fa-id-card-alt',
    iconClass: 'cd'
  },
];